// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"audienceFileMessage_mainContainer__1TopQ","userImg":"audienceFileMessage_userImg__36I2i","messageContainer":"audienceFileMessage_messageContainer__20z_d"};